import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  flex-direction: row;
  //margin-bottom: 18px;
  font-size: 13px;
  font-family: Roboto, sans-serif;
  gap: 5px;

  label {
    font-size: 12px;
    font-weight: normal;
    font-family: Roboto, sans-serif;
   // color: #333333;
    margin-top: 2px;
    cursor: pointer;
  }
`;

